/* eslint-disable import/no-duplicates */
/* eslint-disable no-undef */
// App.js - WEB
import loadable from '@loadable/component';
import React, { Component } from 'react';
import { View } from 'react-native';
import { MenuProvider } from 'react-native-popup-menu';
import Notifications from 'react-notify-toast';
import { Switch } from 'react-router-dom';
import { AppProvider } from './AppContext';
import CacheBuster from './CacheBuster';
import IdleTimer from 'react-idle-timer';
import { APP_TIMEOUT, DEBOUNCE_TIMEOUT } from './constants/configConstants';
import { BILLER_NAME, getPrefData, RESCOUNTRYCODE, SIGNIN_OTP_VERIFIED, COUNTRY_NAME, SESSION_ID, CUST_ID, RESCOUNTRYID, LOGIN_ID, USER_ID, PREF_AUTH_TOKEN, YODLEE_INFO, FIREFOX_INFO, UTM_ARRAY, storePrefData } from './storage/preferenceStorage';
import { getURLPathname } from './utils';
import RoutesGenerator from './utils/route_wrapper';
import { browserSupport, callLogout, getSessionValue, clearStorage, mobileCheck } from './utils/appUtils';
import { GA_TRACKING_ID } from './utils/domainUrl';
import ReactGA from 'react-ga';
import packageJson from '../package.json';
import { getAllUrlParams, urlCheck } from './utils/helperUtils';
import { getCustomStorage } from './storage';
// import {
//   default as Registration,
//   default as RegistrationBusiness,
//   default as RegistrationIndividual,
// } from './pages/signUp/SignUpMainPage';

const Registration = loadable(() => import('./pages/signUp/SignUpMainPage'));
const RegistrationLogin = loadable(() => import('./pages/signUp/SignUpMainPage'));
const RegistrationUs = loadable(() => import('./pages/signUp/SignUpMainPage'));
const RegistrationCanada = loadable(() => import('./pages/signUp/SignUpMainPage'));
const RegistrationUk = loadable(() => import('./pages/signUp/SignUpMainPage'));
const RegistrationUae = loadable(() => import('./pages/signUp/SignUpMainPage'));
const ForgotUserId = loadable(() => import('./pages/signUp/SignUpMainPage'));
const ForgotUserIdUs = loadable(() => import('./pages/signUp/SignUpMainPage'));
const ForgotUserIdUk = loadable(() => import('./pages/signUp/SignUpMainPage'));
const ForgotUserIdUae = loadable(() => import('./pages/signUp/SignUpMainPage'));
const ForgotUserIdCanada = loadable(() => import('./pages/signUp/SignUpMainPage'));
const ForgotPassword = loadable(() => import('./pages/signUp/SignUpMainPage'));
const ForgotPasswordUs = loadable(() => import('./pages/signUp/SignUpMainPage'));
const ForgotPasswordCanada = loadable(() => import('./pages/signUp/SignUpMainPage'));
const ForgotPasswordUk = loadable(() => import('./pages/signUp/SignUpMainPage'));
const ForgotPasswordUae = loadable(() => import('./pages/signUp/SignUpMainPage'));
const UserIdLocked = loadable(() => import('./pages/signUp/SignUpMainPage'));
const UserIdLockedUs = loadable(() => import('./pages/signUp/SignUpMainPage'));
const UserIdLockedCanada = loadable(() => import('./pages/signUp/SignUpMainPage'));
const UserIdLockedUk = loadable(() => import('./pages/signUp/SignUpMainPage'));
const UserIdLockedUae = loadable(() => import('./pages/signUp/SignUpMainPage'));
const RegistrationBusiness = loadable(() => import('./pages/signUp/SignUpMainPage'));
const RegistrationIndividual = loadable(() => import('./pages/signUp/SignUpMainPage'));
const RegistrationIndividualDefault = loadable(() => import('./pages/signUp/SignUpMainPage'));
const RegistrationIndividualUs = loadable(() => import('./pages/signUp/SignUpMainPage'));
const RegistrationIndividualUk = loadable(() => import('./pages/signUp/SignUpMainPage'));
const RegistrationIndividualUae = loadable(() => import('./pages/signUp/SignUpMainPage'));
const RegistrationIndividualCanada = loadable(() => import('./pages/signUp/SignUpMainPage'));
const ErrorPage404Page = loadable(() => import('./pages/404_error_page/404ErrorPage'));
// import iconFont from './assets/fonts/icomoon.ttf';
const LoaderComponent = loadable(() => import('./components/loaderComponent'));
const Toast = loadable(() => import('./components/Toast'));
const ErrorPage404 = loadable(() => import('./pages/404_error_page/404ErrorPage'));
// import NewAddAccount from './pages/account_details/sender_account_details/branchDetails';
const AccountDetails = loadable(() => import(/* webpackPrefetch: true */ './pages/account_details/common_account_details/accountDetails'));
const RenderAddAccountPage = loadable(() =>
  import(
    /* webpackPrefetch: true */
    './pages/account_details/common_account_details/addAccountNonUs/renderAddAccount'
  )
);
const SelectAccountDetails = loadable(() => import(/* webpackPrefetch: true */ './pages/account_details/common_account_details/selectAccountDetails'));
const SetPasscode = loadable(() => import(/* webpackPrefetch: true */ './pages/account_details/common_account_details/setPasscode'));
const NewAddAccount = loadable(() => import(/* webpackPrefetch: true */ './pages/account_details/sender_account_details/branchDetails'));
const Reverification = loadable(() => import(/* webpackPrefetch: true */ './pages/account_details/sender_account_details/reverification'));
const SenderReceipt = loadable(() => import(/* webpackPrefetch: true */ './pages/account_details/sender_account_details/senderReceipt'));
const YodleeThankYouPage = loadable(() => import(/* webpackPrefetch: true */ './pages/account_details/sender_account_details/yodleeThankYouPage'));
// import AddRecipientForNewUser from './pages/add-recipient-new-user/addRecipientLandingForNewUser';
const MyRecipients = loadable(() => import(/* webpackPrefetch: true */ './pages/addRecipient/AddRecipient'));
const RecipientAddress = loadable(() => import(/* webpackPrefetch: true */ './pages/addRecipient/business/recipientAddress'));
const RecipientInfoBusiness = loadable(() => import(/* webpackPrefetch: true */ './pages/addRecipient/business/recipientInfo'));
const RecipientBankDetails = loadable(() => import(/* webpackPrefetch: true */ './pages/addRecipient/individual/bankDetailsIndividual'));
const RecipientInfoIndividual = loadable(() => import(/* webpackPrefetch: true */ './pages/addRecipient/individual/recpInfoIndividual'));
const AddRecipientDetails = loadable(() => import(/* webpackPrefetch: true */ './pages/addRecipient/recpDetails'));
// import AddGasAgency from './pages/add_biller/gas/addGasAgencyDetails';
// import GasAgency from './pages/add_biller/gas/gasAgency';
const AddInsurance = loadable(() => import(/* webpackPrefetch: true */ './pages/add_biller/insurance_provider/addPolicyDetails'));
const Insurance = loadable(() => import(/* webpackPrefetch: true */ './pages/add_biller/insurance_provider/insurance'));
const PolicyDetails = loadable(() => import(/* webpackPrefetch: true */ './pages/add_biller/insurance_provider/policyDetails'));
const AddLandline = loadable(() => import(/* webpackPrefetch: true */ './pages/add_biller/landline/addLandline'));
const BillingStatus = loadable(() => import(/* webpackPrefetch: true */ './pages/add_biller/landline/billingStatus'));
const MakeDonation = loadable(() => import(/* webpackPrefetch: true */ './pages/add_biller/landline/donationList'));
const LandlineServiceProvider = loadable(() => import(/* webpackPrefetch: true */ './pages/add_biller/landline/landlineServiceProvider'));
const personalDetails = loadable(() => import(/* webpackPrefetch: true */ './pages/add_biller/landline/personalDetails'));
const ExpressDelivery = loadable(() => import(/* webpackPrefetch: true */ './pages/amount_transfer/expressDelivery'));
// import NewOtp from './pages/login/newOtp';
const ExpressDeliveryMobile = loadable(() => import(/* webpackPrefetch: true */ './pages/amount_transfer/expressDeliveryMobile'));
const MobileViewExpressDelivery = loadable(() => import(/* webpackPrefetch: true */ './pages/amount_transfer/mobileViewExpressDelivery'));
const RecipientRequest = loadable(() => import(/* webpackPrefetch: true */ './pages/amount_transfer/recipientRequest'));
const SendMoneyForNewUser = loadable(() => import(/* webpackPrefetch: true */ './pages/amount_transfer/sendMoneyForNewUser'));
const SendMoneyForRegUser = loadable(() => import(/* webpackPrefetch: true */ './pages/amount_transfer/sendMoneyForRegUser'));
const TransactionDetails = loadable(() => import(/* webpackPrefetch: true */ './pages/amount_transfer/transactionDetails'));
const AboutTheBusiness = loadable(() => import(/* webpackPrefetch: true */ './pages/businessSignUp/aboutTheBusiness'));
const AuthorizedPerson = loadable(() => import(/* webpackPrefetch: true */ './pages/businessSignUp/authorizedPerson'));
const AuthorizedPersonAddress = loadable(() => import(/* webpackPrefetch: true */ './pages/businessSignUp/authorizedPersonAddress'));
const BusinessAddress = loadable(() => import(/* webpackPrefetch: true */ './pages/businessSignUp/businessAddress'));
const BusinessReceipt = loadable(() => import(/* webpackPrefetch: true */ './pages/businessSignUp/businessReciept'));
const ChangePassword = loadable(() => import(/* webpackPrefetch: true */ './pages/changePassword/changePassword'));
const Confirmation = loadable(() => import(/* webpackPrefetch: true */ './pages/confirmPay/confirmation'));
const HighValueTransaction = loadable(() => import(/* webpackPrefetch: true */ './pages/confirmPay/highValueTransaction'));
// import Confirmation from './pages/confirmPay/confirmation';
const Popup = loadable(() => import(/* webpackPrefetch: true */ './pages/confirmPay/popup'));

const PowerProduct = loadable(() => import(/* webpackPrefetch: true */ './pages/confirmPay/powerProduct'));

const NetExpressProduct = loadable(() => import(/* webpackPrefetch: true */ './pages/confirmPay/netExpressProduct'));

const Reciept = loadable(() => import(/* webpackPrefetch: true */ './pages/confirmPay/reciept'));
const ThankYouPage = loadable(() => import(/* webpackPrefetch: true */ './pages/confirmPay/thankYouPage'));
// import ThankYouPage from './pages/confirmPay/thankyou';
const ContactUs = loadable(() => import(/* webpackPrefetch: true */ './pages/contact/contact'));
const ContactUsUs = loadable(() => import(/* webpackPrefetch: true */ './pages/contact/contact'));
const ContactUsCanada = loadable(() => import(/* webpackPrefetch: true */ './pages/contact/contact'));
const ContactUsUk = loadable(() => import(/* webpackPrefetch: true */ './pages/contact/contact'));
const ContactUsUae = loadable(() => import(/* webpackPrefetch: true */ './pages/contact/contact'));
const HomePage = loadable(() => import(/* webpackPrefetch: true */ './pages/home/landingPage'));
const CompleteURKYCNow = loadable(() => import('./pages/uploaddocuments/ZeroLimitPage'));
const SSOHomePage = loadable(() => import(/* webpackPrefetch: true */ './pages/home/sso-home'));
const Landing = loadable(() => import(/* webpackPrefetch: true */ './pages/landing/landing'));
const DemoDropdown = loadable(() => import(/* webpackPrefetch: true */ './pages/login/demo_dropdown'));
// const ForgotPassword = loadable(() => import('./pages/login/forgotPassword'));
// const ForgotUserId = loadable(() => import('./pages/login/forgotUID'));
const OtpForgotPassword = loadable(() => import(/* webpackPrefetch: true */ './pages/login/otpForgotPassword'));
const ResetPasswordLink = loadable(() => import(/* webpackPrefetch: true */ './pages/login/resetPasswordUsingLink'));
const ResetPasswordNonUs = loadable(() => import(/* webpackPrefetch: true */ './pages/login/resetPasswordNonus'));
// import ResetPasswordLink from './pages/login/resetPasswordLink';
// const UserIdLocked = loadable(() => import('./pages/login/useridlocked'));
const Logout = loadable(() => import(/* webpackPrefetch: true */ './pages/Logout/logout'));
const ManageBiller = loadable(() => import(/* webpackPrefetch: true */ './pages/manage_billers/manageBillers'));

const MyProfile = loadable(() => import(/* webpackPrefetch: true */ './pages/my_profile/myProfile'));
const MyProfileD2D = loadable(() => import(/* webpackPrefetch: true */ './pages/my_profile/myProfileD2D'));
const MyProfileBusiness = loadable(() => import(/* webpackPrefetch: true */ './pages/my_profile/myProfileBusiness'));
const MyRewards = loadable(() => import(/* webpackPrefetch: true */ './pages/my_rewards/myRewards'));
const MyTransactions = loadable(() => import(/* webpackPrefetch: true */ './pages/my_transaction/myTransaction'));
const AllNotificationsPage = loadable(() => import(/* webpackPrefetch: true */ './pages/notification/allNotificationPage'));
// eslint-disable-next-line import/no-duplicates
const ModelNotification = loadable(() => import('./pages/notification/modelNotificationLanding'));
const BillPayments = loadable(() => import('./pages/pay_bills/billPayments'));
// import HighValueTransaction from './pages/confirmPay/highValueTransaction';
const PayBillConfirm = loadable(() => import('./pages/pay_bills/payBillConfirm'));
const PayBills = loadable(() => import('./pages/pay_bills/payBills'));
const PersonalDetail = loadable(() => import('./pages/personal_details/aboutUs'));
const PersonalDetailAddress = loadable(() => import('./pages/personal_details/currentAddress'));
const PersonalDetailReview = loadable(() => import('./pages/personal_details/reviewPersonalDetail'));
const MyRecipient = loadable(() => import('./pages/recipients/myRecipients'));
const ReferAFriend = loadable(() => import('./pages/referFriend/referAFriend'));
const ReferFriendNLI = loadable(() => import('./pages/referFriend/referFriendNLI'));
const AddAccount = loadable(() => import('./pages/senderDetails/add_account/index'));
const ManageMyAccounts = loadable(() => import('./pages/senderDetails/manage_accounts/manage-my-account'));
const confirmPassword = loadable(() => import('./pages/signUp/confirmPassword'));
const otpPopUp = loadable(() => import('./pages/signUp/otpPopUp'));

const SignupSSO = loadable(() => import('./pages/socialPay/signUpSso'));
const SignupSSOUs = loadable(() => import('./pages/socialPay/signUpSso'));
const SignupSSOCanada = loadable(() => import('./pages/socialPay/signUpSso'));
const SignupSSOUk = loadable(() => import('./pages/socialPay/signUpSso'));
const SignupSSOUae = loadable(() => import('./pages/socialPay/signUpSso'));
const SubDollarVerification = loadable(() => import('./pages/subDollarVerification/subDollarVerify'));
const TrackConnection = loadable(() => import('./pages/trackConnection/trackConnection'));
const TrackTransfer = loadable(() => import('./pages/trackConnection/trackTransfer'));
const TrackTransferUs = loadable(() => import('./pages/trackConnection/trackTransfer'));
const TrackTransferCanada = loadable(() => import('./pages/trackConnection/trackTransfer'));
const TrackTransferUk = loadable(() => import('./pages/trackConnection/trackTransfer'));
const TrackTransferUae = loadable(() => import('./pages/trackConnection/trackTransfer'));
const LNFailureBusiness = loadable(() => import('./pages/uploaddocuments/lnDocumentBusiness/lnFailure'));
const LNSuccessBusiness = loadable(() => import('./pages/uploaddocuments/lnDocumentBusiness/lnSuccess'));
const PaystubUploadDocument = loadable(() => import('./pages/uploaddocuments/paystubUploaddocument'));
const PowerDocuments = loadable(() => import('./pages/uploaddocuments/powerDocuments'));
const UploadDocumentLN = loadable(() => import('./pages/uploaddocuments/uploadDocLN'));
const UploadDocAddAccount = loadable(() => import('./pages/uploaddocuments/uploadLNaddAcc'));
// import SelectAccountDetails from './pages/account_details/common_account_details/selectAccountDetails';
const UploadDocument = loadable(() => import('./pages/uploaddocuments/uploaddocuments'));
const CountryLanding = loadable(() => import('./pages/landing/CountryLanding'));
const HowItWorks = loadable(() => import('./pages/how_it_works/howItWorks'));

// Disable the right click
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  // dev code
} else {
  // production code
  window.onload = function () {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    });
    document.addEventListener('keydown', function (e) {
      // document.onkeydown = function(e) {
      // "I" key
      if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
        disabledEvent(e);
      }
      // "J" key
      if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
        disabledEvent(e);
      }
      // "S" key + macOS
      if (e.keyCode === 83 && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
        disabledEvent(e);
      }
      // "U" key
      if (e.ctrlKey && e.keyCode === 85) {
        disabledEvent(e);
      }
      // "F12" key
      if (e.keyCode === 123) {
        disabledEvent(e);
      }
    });
    function disabledEvent(e) {
      if (e.stopPropagation) {
        e.stopPropagation();
      } else if (window.event) {
        window.event.cancelBubble = true;
      }
      e.preventDefault();
      return false;
    }
  };
  document.addEventListener('contextmenu', event => event.preventDefault());
}

export const secKey = process.env.REACT_APP_KEY;
class App extends Component {
  constructor(props) {
    super(props);
    this.Toaster = React.createRef();
    this.loader = React.createRef();
    this.state = {
      showToast: false,
      message: null,
      duration: null,
      ShowToast: this.showToast,
      align: null,
      position: null,
      toastStyle: null,
      errortype: null,
      ShowLoader: this.showLoader,
      countryCode: '',
      currencyValue: '',
      billerName: '',
      countryName: this.getCountryName(),
      routeMap: {},
      lusrID:"",
      lcustId:"",
      handleAppStateChange: this.handleAppStateChange
    };
    this.handleWindowPerformanceEvents();
    this.idleTimer = null;
    this.handleOnAction = this.handleOnAction.bind(this);
    this.handleOnActive = this.handleOnActive.bind(this);
    this.handleOnIdle = this.handleOnIdle.bind(this);
    this.isMobileBrowser = '';

    if (getURLPathname() === '') {
      window.dataLayer = window.dataLayer || [];
      // eslint-disable-next-line no-undef
      dataLayer.push({
        event: 'NewVirtualPageview',
        Page: `VPV/M2I/` // replace with page path
      });
    }
  }

  getCountryName() {
    const windowPath = window.location.pathname.split('/');
    const countryName = getCustomStorage(COUNTRY_NAME);
    let country = windowPath[1].includes('usa') || windowPath[1].includes('uae')
      ? windowPath[1]
      : countryName
        ? countryName
        : '';
    return country;
  }

  componentDidMount() {
    var url = window.location.href.split('/');
    let index1 = url[url.length - 1];
    let index2 = url[url.length - 2];
    let indeex3 = url[url.length - 3];
    let stringval = `${indeex3}/${index2}/${index1}`;
    if (stringval.includes('registration/')) {
      storePrefData(UTM_ARRAY, getAllUrlParams(window.location.href));
    }
    if (stringval.includes('registration/individual/1?site=') || stringval.includes('registration/individual/2?site=') || stringval.includes('registration/individual/3?site=') || stringval.includes('registration/individual/4?site=') || stringval.includes('registration/individual/5?site=') || stringval.includes('registration/individual/6?site=') || stringval.includes('registration/individual/7?site=') || stringval.includes('registration/individual/8?site=') || stringval.includes('registration/individual/9?site=') || stringval.includes('registration/individual/10?site=') || stringval.includes('registration/business/1?site=') || stringval.includes('registration/business/2?site=') || stringval.includes('registration/business/3?site=') || stringval.includes('registration/business/4?site=') || stringval.includes('registration/business/5?site=') || stringval.includes('registration/business/6?site=') || stringval.includes('registration/business/7?site=') || stringval.includes('registration/business/8?site=') || stringval.includes('registration/business/9?site=') || stringval.includes('registration/business/10?site=') || stringval === 'registration/individual/1' || stringval === 'registration/individual/2' || stringval === 'registration/individual/3' || stringval === 'registration/individual/4' || stringval === 'registration/individual/5' || stringval === 'registration/individual/6' || stringval === 'registration/individual/7' || stringval === 'registration/individual/8' || stringval === 'registration/individual/9' || stringval === 'registration/individual/10' || stringval === 'registration/business/1' || stringval === 'registration/business/2' || stringval === 'registration/business/3' || stringval === 'registration/business/4' || stringval === 'registration/business/5' || stringval === 'registration/business/6' || stringval === 'registration/business/7' || stringval === 'registration/business/8' || stringval === 'registration/business/9' || stringval === 'registration/business/10') {
      let indexvalue = getURLPathname();
      if (indexvalue.includes('site')) {
        if (indexvalue.charAt(0) === '1' && indexvalue.charAt(1) === '0') {
          indexvalue = '10';
        } else {
          indexvalue = indexvalue.charAt(0);
        }
      }
      this.setState({ extraPagePath: true, indexvalue: indexvalue });
    } else {
      this.setState({
        extraPagePath: false
      });
    }
    this.isMobileBrowser = mobileCheck();
    const sessionId = getSessionValue(SESSION_ID);
    ReactGA.initialize(GA_TRACKING_ID);
    //ga('create', GA_TRACKING_ID, 'auto', 'm2igtm');

    if (!sessionId) {
      if (!process.env.NODE_ENV || process.env.NODE_ENV !== 'development' || (!getURLPathname().includes('contact-us') && typeof InstallTrigger === 'undefined')) {
        this.userLogout();
      }
    }
    console.log('APP VERSION =', packageJson.version);
    this.createRoutes();
  }

  async userLogout() {
    const isSignedIn = await getPrefData(SIGNIN_OTP_VERIFIED);
    if (isSignedIn) {
      const custId = await getPrefData(CUST_ID);
      const countryId = await getPrefData(RESCOUNTRYID);
      const loginId = await getPrefData(LOGIN_ID);
      const emailId = await getPrefData(USER_ID);
      const auth = await getPrefData(PREF_AUTH_TOKEN);
      const yodleeInfo = await getPrefData(YODLEE_INFO);
      if (!yodleeInfo) {
        callLogout(loginId, custId, countryId, emailId, auth);
      }
    }
  }

  async componentDidUpdate() {
    const countryName = await getPrefData(COUNTRY_NAME);
    
    if (typeof window.history.pushState === 'function') {
      window.history.pushState('jibberish', null, null);
      window.onpopstate = function () {
        window.history.pushState('newjibberish', null, null);
        // Handle the back (or forward) buttons here
        // Will NOT handle refresh, use onbeforeunload for this.

        const validUrl = urlCheck(window.location.origin);

        if (getURLPathname() !== 'individual' && getURLPathname() !== 'business' && getURLPathname() !== 'login' && getURLPathname() !== 'logout' && getURLPathname() !== '' && !getURLPathname().includes('contact-us') && !getURLPathname().includes('refer-friend-NLI') && !getURLPathname().includes('reset-password-link') && !getURLPathname().includes('secureId') && !getURLPathname().includes('forget-user-id') && !getURLPathname().includes('forgot-password') && !getURLPathname().includes('user-id-locked') && !getURLPathname().includes('signup-sso') && !getURLPathname().includes('track-money-transfer')) {
          alert('Browser back functionality is not allowed due to enhanced security, please relogin');
          window.location.replace(validUrl ? `${window.location.origin}/${countryName}/logout` : '');
        } else {
          window.location.replace(validUrl ? `${window.location.origin}/` : '');
        }
      };
    } else {
      var ignoreHashChange = true;
      window.onhashchange = function () {
        if (!ignoreHashChange) {
          ignoreHashChange = true;
          window.location.hash = Math.random();
          // Detect and redirect change here
          // Works in older FF and IE9
          // * it does mess with your hash symbol (anchor?) pound sign
          // delimiter on the end of the URL
        } else {
          ignoreHashChange = false;
        }
      };
    }
    if (getURLPathname() === 'personal-detail' || getURLPathname() === 'personal-address') {
      window.addEventListener(
        'beforeunload',
        ev => {
          ev.preventDefault();
          return (ev.returnValue = 'Are you sure you want to close?');
        },
        { passive: true }
      );
    }
  }
  // handleWindowPerformanceEvents = async () => {
  //   const yodleeInfo = await getPrefData(YODLEE_INFO);
  //   const custId = await getPrefData(CUST_ID);
  //   const countryCd = await getPrefData(RESCOUNTRYCODE);
  //   const isFirefox = await getPrefData(FIREFOX_INFO);
  //   const countryName = await getPrefData(COUNTRY_NAME);
  //   if (window.performance) {
  //     if ((performance.navigation.type === 0 && !yodleeInfo && (custId && getURLPathname().includes('contact-us'))) || performance.navigation.type === 1 || (getURLPathname().includes('/sender_receipt') && performance.navigation.type === 2)) {
  //       if (!getURLPathname().includes('blog') && !getURLPathname().includes('blog1') && !getURLPathname().includes('blog2') && !getURLPathname().includes('login') && !getURLPathname().includes('individual') && !getURLPathname().includes('business') && !getURLPathname().includes('logout') && !getURLPathname().includes('reset-password-link') && !getURLPathname().includes('secureId') && !getURLPathname().includes('refer-friend-NLI') && !getURLPathname().includes('forget-user-id') && !getURLPathname().includes('forgot-password') && !getURLPathname().includes('user-id-locked') && !getURLPathname().includes('signup-sso') && !getURLPathname().includes('track-money-transfer') && getURLPathname() !== '/' && getURLPathname() !== '') {
  //         if (!process.env.NODE_ENV || process.env.NODE_ENV !== 'development') {
  //           const validUrl = urlCheck(window.location.origin);

  //           if (performance.navigation.type === 0 && !yodleeInfo && (getURLPathname().includes('contact-us') && custId) && !getURLPathname().includes('404Page')) {
  //             await clearStorage('App.js');
  //             alert('URL update is not allowed');
  //             if (countryCd) {
  //               window.location.replace(validUrl ? `${window.location.origin}/${countryCd.toLowerCase()}/404Page` : '');
  //             } else {
  //               window.location.replace(validUrl ? `${window.location.origin}/404Page` : '');
  //             }
  //           } else if (!getURLPathname().includes('404Page')) {
  //             if (isFirefox) {
  //               // console.log('Firefox info in App.js ', isFirefox);
  //             } else {
  //               await clearStorage('App.js');
  //               alert('Browser back functionality is not allowed due to enhanced security, please relogin');
  //               window.location.replace(validUrl ? `${window.location.origin}/${countryName}/logout` : '');
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // };
  handleWindowPerformanceEvents = async () => {
    const yodleeInfo = await getPrefData(YODLEE_INFO);
    const custId = await getPrefData(CUST_ID);
    const countryCd = await getPrefData(RESCOUNTRYCODE);
    const isFirefox = await getPrefData(FIREFOX_INFO);
    const countryName = await getPrefData(COUNTRY_NAME);
    const validUrl = urlCheck(window.location.origin);
    if (window.performance) {
      if ((performance.navigation.type === 0 && 
          !yodleeInfo && 
          !(custId && getURLPathname().includes('contact-us'))) || 
          performance.navigation.type === 1 || 
          (getURLPathname().includes('/sender_receipt') && 
          performance.navigation.type === 2)) {
        if (
          !getURLPathname().includes('blog') &&
           !getURLPathname().includes('blog1') && 
           !getURLPathname().includes('blog2') && 
           !getURLPathname().includes('login') &&  
           !getURLPathname().includes('individual') && 
            !getURLPathname().includes('business') && 
            !getURLPathname().includes('logout') && 
            !getURLPathname().includes('reset-password-link') && 
            !getURLPathname().includes('secureId') && 
            !getURLPathname().includes('refer-friend-NLI') &&
             !getURLPathname().includes('forget-user-id') && 
             !getURLPathname().includes('forgot-password') &&
              !getURLPathname().includes('user-id-locked') && 
              !getURLPathname().includes('signup-sso') && 
              !getURLPathname().includes('track-money-transfer') && 
              getURLPathname() !== '/' && 
              getURLPathname() !== '') {
          if (!process.env.NODE_ENV || process.env.NODE_ENV !== 'development') {
            // const validUrl = urlCheck(window.location.origin);

            if (performance.navigation.type === 0 && 
              !yodleeInfo && 
              !(getURLPathname().includes('contact-us') && custId) && 
              !getURLPathname().includes('404Page')) {
              await clearStorage('App.js');
              alert('URL update is not allowed');
              if (countryCd) {
                window.location.replace(validUrl ? `${window.location.origin}/${countryCd.toLowerCase()}/404Page` : '');
              } else {
                window.location.replace(validUrl ? `${window.location.origin}/404Page` : '');
              }
            } else if (!getURLPathname().includes('404Page')) {
              if (isFirefox) {
                // console.log('Firefox info in App.js ', isFirefox);
              } else {
                await clearStorage('App.js');
                alert('Browser back functionality is not allowed due to enhanced security, please relogin');
                window.location.replace(validUrl ? `${window.location.origin}/${countryName}/logout` : '');
              }
            }
          }
        }
      }
    }
  };


  handleAppStateChange = props => {
    this.setState(
      {
        currencyValue: props.currencyValue,
        countryName: props.countryName
      },
      function () {
        this.createRoutes();
      }
    );
  };

  checkBillerName = async () => {
    let biller = (await getPrefData(BILLER_NAME)) ? await getPrefData(BILLER_NAME) : '';
    if (biller) {
      biller = biller.toLowerCase().split(' ');
      biller = biller[0];
      this.setState({
        billerName: biller
      });
    }
  };

  showLoader = props => {
    if (this.loader && this.loader.current) {
      this.loader.current.showLoader(props.isLoading);
    }
  };

  showToast = props => {
    this.Toaster.current.showToast(typeof props.message === 'function' ? props.message() : props.message, props.duration, props.align, props.position, props.toastStyle, props.errortype);
  };
  setContext = props => {
    this.setState(props);
  };

  handleOnAction(event) {
    //console.log('user did something', event);
  }

  handleOnActive(event) {
    //console.log('user is active', event);
    //console.log('time remaining', this.idleTimer.getRemainingTime());
  }

  async handleOnIdle(event) {
    const isSignedIn = await getPrefData(SIGNIN_OTP_VERIFIED);
    const countryName = await getPrefData(COUNTRY_NAME);
    if (isSignedIn === true) {
      alert('Your session is been logged out due to inactivity');
      if (!process.env.NODE_ENV || process.env.NODE_ENV !== 'development') {
        const validUrl = urlCheck(window.location.origin);
        window.location.replace(validUrl ? `${window.location.origin}/${countryName}/logout` : '');
      } else {
        window.location.replace(`${window.location.origin}/${countryName}/logout`);
      }
    }
  }

  createRoutes() {
    const { currencyValue, countryName } = this.state;
    const routeMap = {
      CountryLanding: {
        component: CountryLanding,
        path: `/countryLanding`
      },
      SetPasscode: {
        component: SetPasscode,
        path: countryName ? `/${countryName}/set-passcode` : `/set-passcode`
      },
      ForgotPassword: {
        component: ForgotPassword,
        path: countryName ? `/${countryName}/login/forgot-password` : `/login/forgot-password`
      },
      ForgotPasswordUs: {
        component: ForgotPasswordUs,
        path: `/usa/login/forgot-password`
      },
      ForgotPasswordCanada: {
        component: ForgotPasswordCanada,
        path: `/canada/login/forgot-password`
      },
      ForgotPasswordUk: {
        component: ForgotPasswordUk,
        path: `/uk/login/forgot-password`
      },
      ForgotPasswordUae: {
        component: ForgotPasswordUae,
        path: `/uae/login/forgot-password`
      },
      UserIdLocked: {
        component: UserIdLocked,
        path: countryName ? `/${countryName}/login/user-id-locked` : `/login/user-id-locked`
      },
      UserIdLockedUs: {
        component: UserIdLockedUs,
        path: `/usa/login/user-id-locked`
      },
      UserIdLockedCanada: {
        component: UserIdLockedCanada,
        path: `/canada/login/user-id-locked`
      },
      UserIdLockedUk: {
        component: UserIdLockedUk,
        path: `/uk/login/user-id-locked`
      },
      UserIdLockedUae: {
        component: UserIdLockedUae,
        path: `/uae/login/user-id-locked`
      },
      ForgotUserId: {
        component: ForgotUserId,
        path: countryName ? `/${countryName}/login/forget-user-id` : `/login/forget-user-id`
      },
      ForgotUserIdUs: {
        component: ForgotUserIdUs,
        path: `/usa/login/forget-user-id`
      },
      ForgotUserIdCanada: {
        component: ForgotUserIdCanada,
        path: `/canada/login/forget-user-id`
      },
      ForgotUserIdUk: {
        component: ForgotUserIdUk,
        path: `/uk/login/forget-user-id`
      },
      ForgotUserIdUae: {
        component: ForgotUserIdUae,
        path: `/uae/login/forget-user-id`
      },
      RegistrationUs: {
        component: RegistrationUs,
        path: `/usa/login`,
        // path: `/login`,
        exact: true
      },
      RegistrationCanada: {
        component: RegistrationCanada,
        path: `/canada/login`,
        // path: `/login`,
        exact: true
      },

      RegistrationUk: {
        component: RegistrationUk,
        path: `/uk/login`,
        // path: `/login`,
        exact: true
      },

      RegistrationUae: {
        component: RegistrationUae,
        path: `/uae/login`,
        // path: `/login`,
        exact: true
      },

      Registration: {
        component: Registration,
        path: `/login`,
        exact: true
      },
      RegistrationLogin: {
        component: RegistrationLogin,
        path: `/${countryName}/login`,
        exact: true
      },
      RegistrationBusiness: {
        component: RegistrationBusiness,
        // path: countryName
        //   ? `/${countryName}/registration/business`
        //   : `/registrationbiz`,
        path: this.state.extraPagePath === true ? `/usa/registration/business/${this.state.indexvalue}` : `/usa/registration/business`
        // exact: true,
      },
      RegistrationBusiness1: {
        component: RegistrationBusiness,
        path: `/usa/registration/business/1`
        // exact: true,
      },
      RegistrationBusiness2: {
        component: RegistrationBusiness,
        path: `/usa/registration/business/2`
        // exact: true,
      },
      RegistrationBusiness3: {
        component: RegistrationBusiness,
        path: `/usa/registration/business/3`
        // exact: true,
      },
      RegistrationBusiness4: {
        component: RegistrationBusiness,
        path: `/usa/registration/business/4`
        // exact: true,
      },
      RegistrationBusiness5: {
        component: RegistrationBusiness,
        path: `/usa/registration/business/5`
        // exact: true,
      },
      RegistrationBusiness6: {
        component: RegistrationBusiness,
        path: `/usa/registration/business/6`
        // exact: true,
      },
      RegistrationBusiness7: {
        component: RegistrationBusiness,
        path: `/usa/registration/business/7`
        // exact: true,
      },
      RegistrationBusiness8: {
        component: RegistrationBusiness,
        path: `/usa/registration/business/8`
        // exact: true,
      },
      RegistrationBusiness9: {
        component: RegistrationBusiness,
        path: `/usa/registration/business/9`
        // exact: true,
      },
      RegistrationBusiness10: {
        component: RegistrationBusiness,
        path: `/usa/registration/business/10`
        // exact: true,
      },

      RegistrationIndividual: {
        component: RegistrationIndividual,
        path: `/registration/individual`
        // exact: true,
      },
      RegistrationIndividualDefault: {
        component: RegistrationIndividualDefault,
        path: countryName === 'uk' ? `/registration/individual` : `/${countryName}/registration/individual`
        // exact: true,
      },
      RegistrationIndividualUs: {
        component: RegistrationIndividualUs,
        path: this.state.extraPagePath === true ? `/usa/registration/individual/${this.state.indexvalue}` : `/usa/registration/individual`
      },
      RegistrationIndividualUk: {
        component: RegistrationIndividualUk,
        path: `/uk/registration/individual`
      },
      RegistrationIndividualCanada: {
        component: RegistrationIndividualCanada,
        path: `/canada/registration/individual`
      },
      RegistrationIndividualUae: {
        component: RegistrationIndividualUae,
        path: this.state.extraPagePath === true ? `/uae/registration/individual/${this.state.indexvalue}` : `/uae/registration/individual`
      },
      RenderAddAccountPage: {
        component: RenderAddAccountPage,
        path: countryName ? `/${countryName}/render-add-account` : `/render-add-account`
      },

      AboutTheBusiness: {
        component: AboutTheBusiness,
        path: countryName ? `/${countryName}/about-the-business` : `/about-the-business`
      },
      BusinessAddress: {
        component: BusinessAddress,
        path: countryName ? `/${countryName}/business-address` : `/business-address`
      },
      BusinessReceipt: {
        component: BusinessReceipt,
        path: countryName ? `/${countryName}/business-receipt` : `/business-receipt`
      },
      AuthorizedPerson: {
        component: AuthorizedPerson,
        path: countryName ? `/${countryName}/authorized-person` : `/authorized-person`
      },
      AuthorizedPersonAddress: {
        component: AuthorizedPersonAddress,
        path: countryName ? `/${countryName}/authorized-person-address` : `/authorized-person-address`
      },
      PersonalDetail: {
        component: PersonalDetail,
        path: countryName ? `/${countryName}/personal-detail` : `/personal-detail`,
        exact: true
      },
      PersonalDetailAddress: {
        component: PersonalDetailAddress,
        path: countryName ? `/${countryName}/personal-address` : `/personal-address`,
        exact: true
      },
      PersonalDetailReview: {
        component: PersonalDetailReview,
        path: countryName ? `/${countryName}/personal-detail-review` : `/personal-detail-review`,
        exact: true
      },

      MyRecipientList: {
        component: MyRecipient,
        path: countryName ? `/${countryName}/my-recipients` : `/my-recipients`,
        exact: true
      },
      MyTransaction: {
        component: MyTransactions,
        path: countryName ? `/${countryName}/my-transaction` : `/my-transaction`
      },
      otpPopUp: {
        component: otpPopUp,
        path: countryName ? `/${countryName}/otpPopUp` : `/otpPopUp`
      },
      confirmPassword: {
        component: confirmPassword,
        path: countryName ? `/${countryName}/confirmPassword` : `/confirmPassword`
      },
      Landing: {
        component: HowItWorks,
        path: '/Landing',
        exact: true
      },
      Reciept: {
        component: Reciept,
        path: countryName ? `/${countryName}/reciept` : `/reciept`
      },
      MyRewards: {
        component: MyRewards,
        path: countryName ? `/${countryName}/my-rewards` : `/my-rewards`,
        exact: true
      },
      MyRecipients: {
        component: MyRecipients,
        path: countryName ? `/${countryName}/add-recipients` : `/add-recipients`
      },
      HomePage: {
        component: HomePage,
        path: '/',
        exact: true
      },
      ContactUs: {
        component: ContactUs,
        path: countryName ? `/${countryName}/contact-us` : `/contact-us`,
        exact: true
      },
      ContactUsUs: {
        component: ContactUsUs,
        path: `/usa/contact-us`,
        exact: true
      },
      ContactUsCanada: {
        component: ContactUsCanada,
        path: `/canada/contact-us`,
        exact: true
      },
      ContactUsUk: {
        component: ContactUsUk,
        path: `/uk/contact-us`,
        exact: true
      },
      ContactUsUae: {
        component: ContactUsUae,
        path: `/uae/contact-us`,
        exact: true
      },
      AddAccount: {
        component: AddAccount,
        path: countryName ? `/${countryName}/add-account` : `/add-account`,
        exact: true
      },

      ManageMyAccounts: {
        component: ManageMyAccounts,
        path: countryName ? `/${countryName}/manage-my-account` : `/manage-my-account`,
        exact: true
      },

      ModelNotification: {
        component: ModelNotification,
        path: countryName ? `/${countryName}/ModelNotification` : `/ModelNotification`
      },

      AllNotificationsPage: {
        component: AllNotificationsPage,
        path: countryName ? `/${countryName}/all-notifications` : `/all-notifications`
      },

      Popup: {
        component: Popup,
        path: countryName ? `/${countryName}/popup` : `/popup`
      },
      MyProfile: {
        component: MyProfile,
        path: countryName ? `/${countryName}/profile` : `/profile`
      },
      MyProfileD2D: {
        component: MyProfileD2D,
        path: countryName ? `/${countryName}/profile-D2D` : `/profile-D2D`
      },
      MyProfileBusiness: {
        component: MyProfileBusiness,
        path: countryName ? `/${countryName}/profile-Business` : `/${countryName}/profile-Business`
      },
      DemoDropdown: {
        component: DemoDropdown,
        path: '/demo-dropdown'
      },

      ReferAFriend: {
        component: ReferAFriend,
        path: countryName ? `/${countryName}/refer-friend` : `/refer-friend`
      },

      ReferFriendNLI: {
        component: ReferFriendNLI,
        path: `/refer-friend-NLI`
      },

      SubDollarVerification: {
        component: SubDollarVerification,
        path: countryName ? `/${countryName}/subDollar-verification` : `/subDollar-verification`
      },

      UploadDocument: {
        component: UploadDocument,
        path: countryName ? `/${countryName}/upload-document` : `/upload-document`
      },
      UploadDocumentLN: {
        component: UploadDocumentLN,
        path: countryName ? `/${countryName}/upload-document-ln` : `/upload-document-ln`
      },
      UploadDocAddAccount: {
        component: UploadDocAddAccount,
        path: countryName ? `/${countryName}/upload-document-ln-success` : `/upload-document-ln-success`
      },
      PaystubUploadDocument: {
        component: PaystubUploadDocument,
        path: countryName ? `/${countryName}/paystub-document` : `/paystub-document`
      },
      PowerDocuments: {
        component: PowerDocuments,
        path: countryName ? `/${countryName}/power-document` : `/power-document`
      },
      Logout: {
        component: Logout,
        path: countryName ? `/${countryName}/logout` : `/logout`
      },
      ChangePassword: {
        component: ChangePassword,
        path: countryName ? `/${countryName}/changePassword` : `/changePassword`
      },

      TrackConnection: {
        component: TrackConnection,
        path: countryName ? `/${countryName}/track-money-transfer-result` : `/track-money-transfer-result`,
        exact: true
      },
      TrackTransfer: {
        component: TrackTransfer,
        path: countryName ? `/${countryName}/track-money-transfer` : `/track-money-transfer`,
        exact: true
      },
      TrackTransferUs: {
        component: TrackTransferUs,
        path: `/usa/track-money-transfer`,
        exact: true
      },
      TrackTransferCanada: {
        component: TrackTransferCanada,
        path: `/canada/track-money-transfer`,
        exact: true
      },
      TrackTransferUk: {
        component: TrackTransferUk,
        path: `/uk/track-money-transfer`,
        exact: true
      },
      TrackTransferUae: {
        component: TrackTransferUae,
        path: `/uae/track-money-transfer`,
        exact: true
      },
      ResetPasswordLink: {
        component: ResetPasswordLink,
        path: countryName ? `/${countryName}/reset-password-link/:secureId` : `/reset-password-link/:secureId`
      },
      ResetPasswordNonUs: {
        component: ResetPasswordNonUs,
        path: countryName ? `/${countryName}/resetPassword` : `/resetPassword`
      },

      OtpForgotPassword: {
        component: OtpForgotPassword,
        path: countryName ? `/${countryName}/otpForgotPassword` : `/otpForgotPassword`
      },
      ExpressDelivery: {
        component: ExpressDelivery,
        path: countryName ? `/${countryName}/expressDelivery` : `/expressDelivery`
      },
      RecipientRequest: {
        component: RecipientRequest,
        path: countryName ? `/${countryName}/recipientRequest` : `/recipientRequest`
      },
      ExpressDeliveryMobile: {
        component: ExpressDeliveryMobile,
        path: countryName ? `/${countryName}/expressDeliveryMobile` : `/expressDeliveryMobile`
      },
      MobileViewExpressDelivery: {
        component: MobileViewExpressDelivery,
        path: countryName ? `/${countryName}/mobileViewExpressDelivery` : `/mobileViewExpressDelivery`
      },
      PayBills: {
        component: PayBills,
        path: countryName ? `/${countryName}/pay-bills` : `/pay-bills`
      },
      AddLandline: {
        component: AddLandline,
        path: countryName ? `/${countryName}/pay-bill/add-landline` : `/pay-bill/add-landline`
      },
      BillingStatus: {
        component: BillingStatus,
        path: countryName ? `/${countryName}/pay-bill/billing-status` : `/pay-bill/billing-status`
      },
      LandlineServiceProvider: {
        component: LandlineServiceProvider,
        path: countryName ? `/${countryName}/pay-bill/landline-serviceProvider` : `/pay-bill/landline-serviceProvider`
      },
      Insurance: {
        component: Insurance,
        path: countryName ? `/${countryName}/pay-bill/add-insurance` : `/pay-bill/add-insurance`
      },
      PolicyDetails: {
        component: PolicyDetails,
        path: countryName ? `/${countryName}/pay-bill/policy_details` : `/pay-bill/policy_details`
      },
      AddInsurance: {
        component: AddInsurance,
        path: countryName ? `/${countryName}/pay-bill/add-policy` : `/pay-bill/add-policy`
      },
      ManageBiller: {
        component: ManageBiller,
        path: countryName ? `/${countryName}/pay-bill/manage-billers` : `/pay-bill/manage-billers`
      },
      BillPayments: {
        component: BillPayments,
        path: countryName ? `/${countryName}/pay-bill/bill-payments` : `/pay-bill/bill-payments`
      },

      SelectAccountDetails: {
        component: SelectAccountDetails,
        path: countryName ? `/${countryName}/select_account_details` : `/select_account_details`
      },
      NewAddAccount: {
        component: NewAddAccount,
        path: countryName ? `/${countryName}/new_add_account` : `/new_add_account`
      },
      AccountDetails: {
        component: AccountDetails,
        path: countryName ? `/${countryName}/account_details` : `/account_details`
      },
      SenderReceipt: {
        component: SenderReceipt,
        path: countryName ? `/${countryName}/sender_receipt` : `/sender_receipt`
      },
      SendMoneyForNewUser: {
        component: SendMoneyForNewUser,
        path: countryName ? `/${countryName}/send-money-for-new-user` : `/send-money-for-new-user`
      },
      TransactionDetails: {
        component: TransactionDetails,
        path: countryName ? `/${countryName}/transaction-details` : `/transaction-details`
      },
      SendMoneyForRegUser: {
        component: SendMoneyForRegUser,
        path: countryName ? `/${countryName}/currency-converter/${currencyValue.toString()}` : `/currency-converter`
      },
      Confirmation: {
        component: Confirmation,
        path: countryName ? `/${countryName}/confirmation` : `/confirmation`
      },
      ThankYouPage: {
        component: ThankYouPage,
        path: countryName ? `/${countryName}/thankYouPage` : `/thankYouPage`
      },
      PowerProduct: {
        component: PowerProduct,
        path: countryName ? `/${countryName}/powerProduct` : `/powerProduct`
      },
      NetExpressProduct: {
        component: NetExpressProduct,
        path: countryName ? `/${countryName}/netExpressProduct` : `/netExpressProduct`
      },
      HighValueTransaction: {
        component: HighValueTransaction,
        path: countryName ? `/${countryName}/highValueTransaction` : `/highValueTransaction`
      },
      AddRecipientDetails: {
        component: AddRecipientDetails,
        path: countryName ? `/${countryName}/add-recipientDetails` : `/add-recipientDetails`
      },
      RecipientBankDetails: {
        component: RecipientBankDetails,
        path: countryName ? `/${countryName}/recipientBank-details` : `/recipientBank-details`
      },
      RecipientInfoIndividual: {
        component: RecipientInfoIndividual,
        path: countryName ? `/${countryName}/recipientInfo-individual` : `/recipientInfo-individual`
      },
      RecipientInfoBusiness: {
        component: RecipientInfoBusiness,
        path: countryName ? `/${countryName}/recipientInfo-business` : `/recipientInfo-business`
      },
      RecipientAddress: {
        component: RecipientAddress,
        path: countryName ? `/${countryName}/recipient-address` : `/recipient-address`
      },
      PayBillConfirm: {
        component: PayBillConfirm,
        path: countryName ? `/${countryName}/paybill-confirm` : `/paybill-confirm`
      },
      LNSuccessBusiness: {
        component: LNSuccessBusiness,
        path: countryName ? `/${countryName}/lnSuccess-Business` : `/lnSuccess-Business`
      },
      LNFailureBusiness: {
        component: LNFailureBusiness,
        path: countryName ? `/${countryName}/lnFailure-Business` : `/lnFailure-Business`
      },
      MakeDonation: {
        component: MakeDonation,
        path: countryName ? `/${countryName}/pay-bill/make-donation` : `/pay-bill/make-donation`
      },
      personalDetails: {
        component: personalDetails,
        path: countryName ? `/${countryName}/personal-details` : `/personal-details`
      },
      SSOHomePage: {
        component: SSOHomePage,
        path: '/sso-home'
      },
      Reverification: {
        component: Reverification,
        path: countryName ? `/${countryName}/reverification` : `/reverification`
      },
      YodleeThankYouPage: {
        component: YodleeThankYouPage,
        path: countryName ? `/${countryName}/yodlee-page` : `/yodlee-page`
      },
      SignupSSO: {
        component: SignupSSO,
        path: countryName ? `/${countryName}/signup-sso` : `/signup-sso`
      },
      SignupSSOUs: {
        component: SignupSSOUs,
        path: `/usa/signup-sso`
      },
      SignupSSOCanada: {
        component: SignupSSOCanada,
        path: `/canada/signup-sso`
      },
      SignupSSOUk: {
        component: SignupSSOUk,
        path: `/uk/signup-sso`
      },
      SignupSSOUae: {
        component: SignupSSOUae,
        path: `/uae/signup-sso`
      },
      CompleteURKYCNow: {
        component: CompleteURKYCNow,
        path: countryName ? `/${countryName}/complete-your-kyc-now` : `/complete-your-kyc-now`
      },
      ErrorPage404: {
        component: ErrorPage404
      }
      // HowItWorks: {
      //   component: HowItWorks,
      //   path: `/usa/how-it-works`
      // }

      // ErrorPage404Page: {
      //   component: ErrorPage404Page,
      //   path: countryName ? `/${countryName}/404Page` : `/404Page`,
      // },
    };

    this.setState({ routeMap });
  }

  render() {
    const { showToast, routeMap, message, duration, align, position, toastStyle, errortype, currencyValue, countryName,lusrID,lcustId } = this.state;
    let values = { ...this.state, setContext: val => this.setContext(val) };

    // this.checkBillerName();

    return (
      <IdleTimer
        ref={ref => {
          this.idleTimer = ref;
        }}
        timeout={APP_TIMEOUT}
        onActive={this.handleOnActive}
        onIdle={this.handleOnIdle}
        onAction={this.handleOnAction}
        debounce={DEBOUNCE_TIMEOUT}>
        <CacheBuster>
          {({ loading, isLatestVersion, refreshCacheAndReload }) => {
            if (loading) return null;
            if (!loading && !isLatestVersion) {
              refreshCacheAndReload();
            } else {
              return (
                <View style={{ flex: 1 }}>
                  {browserSupport(window.navigator.userAgent) === true ? (
                    <AppProvider value={values}>
                      <MenuProvider>
                        <View
                          style={{
                            backgroundColor: '#fcfcfc',
                            height: '100vh',
                            width: '100vw',
                            overflowX: this.isMobileBrowser === true ? 'visible' : 'hidden'
                          }}>
                          <Switch>{RoutesGenerator({ routeMap })}</Switch>
                        </View>
                        <Notifications></Notifications>

                        <Toast ref={this.Toaster} showToast={showToast} message={message} duration={duration} position={position} align={align} toastStyle={toastStyle} errortype={errortype} />
                      </MenuProvider>

                      <LoaderComponent ref={this.loader} />
                    </AppProvider>
                  ) : null}
                </View>
              );
            }
          }}
        </CacheBuster>
      </IdleTimer>
    );
  }
}

export default App;
